import { IGetPaymentCommission } from 'src/store/api/paymentCommission/types';
import { createReducer } from '@reduxjs/toolkit';

import { paymentCommissionsFiltersActions } from './actions';

const initialState: IGetPaymentCommission = {
  params: {
    sort: 'id,desc',
    size: '10',
    page: '0',
  },
  data: {},
};

const paymentCommissionsFiltersReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(paymentCommissionsFiltersActions.setParams, (state, action) => ({
      ...state,
      params: action.payload,
    }))
    .addCase(paymentCommissionsFiltersActions.setBody, (state, action) => ({
      ...state,
      data: action.payload,
    }))
    .addCase(paymentCommissionsFiltersActions.clearBody, (state) => ({
      ...state,
      data: initialState.data,
    }))
    .addCase(paymentCommissionsFiltersActions.clearCurr, () => initialState),
);

export { paymentCommissionsFiltersReducer };
